export default __webpack_public_path__ + "static/media/healthInsurance_main.25354d99.jpg";